import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { httpAPI_FAC019, httpAPI_STA025, httpAPI_STA032 } from "./api/request";
import { searchFormList, searchFormSchema } from "./parts";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { ConfirmStatus } from "../../assets/data/Constants";
import dayjs from "dayjs";
import StaffListTable from "./components/components";
import { IAPI_STA025_Response } from "../../type/apiType";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRW060101 従業状況更新
 * @return SCRW060101 従業状況更新
 */
const SCRW060101 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [facilityList, setFacilityList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const [changeListFirst, setChangeListFirst] = useState<any>([]);
  const disabled =
    businessState.common?.businessType === "JOB-10" &&
    !!location.state?.applyId;
  const [selectFacilityNo, setSelectFacilityNo] = useState<any>();
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [stateSearchList, setStateSearchList] = useState(searchFormList);
  const [openWarning, setOpenWarning] = useState(false);

  const resRef = useRef<IAPI_STA025_Response>({});
  const res = resRef.current;
  const setRes = (data: IAPI_STA025_Response) => {
    resRef.current = data;
  };
  const stateStaffListRef = useRef<any>([]);
  const stateStaffList = stateStaffListRef.current;
  const setStateStaffList = (data: any) => {
    stateStaffListRef.current = data;
  };

  const staffNameRef = useRef("");
  const staffName = staffNameRef.current;
  const setStaffName = (value: string) => {
    staffNameRef.current = value;
  };

  const currentStaffNoRef = useRef("");
  const currentStaffNo = currentStaffNoRef.current;
  const setCurrentStaffNo = (value: string) => {
    currentStaffNoRef.current = value;
  };

  const [dateErrorFlg, setDateErrorFlg] = useState(false);

  const handleInit = async () => {
    // プルダウン用有効施設一覧参照API 呼び出し
    try {
      const res = await httpAPI_FAC019({
        contractorNo: businessState.common?.contractorNo,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        let dataList = res.facilityList!.map((item) => ({
          value: item.facilityNo,
          label: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        }));
        setFacilityList(dataList ?? []);

        if (businessState.employeeStatusUpdate?.selectedFacilityNo) {
          setSelectFacilityNo(
            businessState.employeeStatusUpdate?.selectedFacilityNo
          );
          setStaffName(
            businessState.employeeStatusUpdate?.selectedStaffName ?? ""
          );
          let resArr = stateSearchList;
          resArr.find((item) => item.keyword === "name")!.wantToSetValue =
            businessState.employeeStatusUpdate?.selectedStaffName;
          setStateSearchList([...resArr]);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeFacility = async (
    value: any,
    type: "change" | "search"
  ) => {
    if (type === "change") {
      setSelectFacilityNo(value);
      if (!value) return;
    }

    // 従業状況更新参照API 呼び出し
    try {
      const res = await httpAPI_STA025({
        contractorNo: businessState.common?.contractorNo!,
        facilityNo: type === "change" ? value : selectFacilityNo,
        staffName: type === "search" ? value : staffName,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setBusinessState({
          ...businessState,
          employeeStatusUpdate: {
            ...businessState.employeeStatusUpdate,
            selectedStaffName: type === "search" ? value : staffName,
          },
        });
        setRes(res);
        setStaffName("");
        setChangeListFirst(res.staffList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 育児休業情報登録
  const handleSure = () => {
    setBusinessState({
      ...businessState,
      employeeStatusUpdate: {
        ...businessState.employeeStatusUpdate,
        selectedFacilityNo: selectFacilityNo,
      },
    });

    navigate("/SCRC060101", { state: { staffNo: currentStaffNo } });
  };

  //登録ボタン押下
  const handleClickSubmit = () => {
    if (res.staffList && stateStaffListRef.current) {
      //業務チェック
      const today = new Date();
      const nextYearDate = new Date(today.setFullYear(today.getFullYear() + 1));
      const updatedChangeRetireDateList = stateStaffListRef.current.filter(
        (item: any, index: any) => {
          return item.retireDate !== res?.staffList![index].retireDate;
        }
      );
      const result = updatedChangeRetireDateList?.some((item: any) => {
        const retireDate = new Date(item?.retireDate!);
        nextYearDate.setHours(0, 0, 0, 0);
        retireDate.setHours(0, 0, 0, 0);
        return retireDate >= nextYearDate;
      });
      if (result) {
        //入出力項目.退職（予定）日 ≧ システム日付 + 1年
        setOpenWarning(true);
      } else {
        setOpenDialog2(true);
      }
    } else {
      setOpenDialog2(true);
    }
  };

  // 登録
  const handleLogin = async () => {
    let result = false;
    try {
      stateStaffList?.forEach((staff: any) => {
        if (!staff.retireDate) return;
        const resStaffList = changeListFirst?.find(
          (item: any) => item.staffNo === staff.staffNo
        );
        // 更新していないときはチェックしない
        if (resStaffList?.retireDate === staff.retireDate) return;

        const retireDate = dayjs(staff.retireDate);
        const confirmStatus = state.authInfo?.confirmStatus;
        const fiscalYear = state.authInfo?.fiscalYear!;
        if (
          confirmStatus === ConfirmStatus["未確定"] ||
          confirmStatus === ConfirmStatus["確定中"]
        ) {
          // 当年度の掛金確定前 かつ 入力内容.退職（予定）日 ≦ 前々年度末（３月３１日）
          if (retireDate.isBefore(dayjs(`${fiscalYear - 1}/04/01`))) {
            setState({
              ...state,
              errorMsgId: "TKMSG_SCR0033E",
            });
            result = true;
            setOpenDialog2(false);
          }
        }
      });
    } catch (error) {
      result = false;
    }

    if (result) return;

    let staffList = _.cloneDeep(stateStaffList);
    staffList.forEach((item: any) => {
      delete item.staffNameKanji;
      delete item.createUser;
      delete item.loackState;
      delete item.birthday;
    });

    // 日々更新法人職員系TBLの更新API 呼び出し
    try {
      const res = await httpAPI_STA032({
        contractorNo: businessState.common?.contractorNo,
        staffList,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setOpenDialog2(false);
        let routerList = stateRouter.routerList || [];
        if (routerList.length > 1) {
          setStateRouter({
            ...stateRouter,
            routerList: [...routerList.slice(0, routerList.length - 1)],
          });
          navigate(`${routerList[routerList.length - 2].href}`);
        } else {
          setStateRouter({});
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOpenSubmitModal = () => {
    setOpenWarning(false);
    setOpenDialog2(true);
  };

  return (
    <Box className="SCRW060101" data-testid="SCRW060101PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW060101_01}</TkInfoManual>
      <TkContractorAndNumberLine
        name="契約者（法人）名"
        no={
          businessState.common?.contractorNo! +
          ":" +
          businessState.common?.contractorName!
        }
      />
      <TkFakeTableLine
        title="施設選択"
        type="selectForm"
        selectPropsList={facilityList}
        setDefaultValue={
          facilityList.length
            ? businessState.employeeStatusUpdate?.selectedFacilityNo
            : ""
        }
        onChange={(e: any) => handleChangeFacility(e.target.value, "change")}
      />

      {selectFacilityNo && (
        <Box>
          <TkInfoManual rule={"\\n"}>
            {labelids.labelid.LBLW060101_02}
          </TkInfoManual>
          <TkSearchForm
            listData={stateSearchList}
            ruleSchema={searchFormSchema}
            onSearch={(e: any) => handleChangeFacility(e.name, "search")}
          />
          <StaffListTable
            res={res}
            disabled={disabled}
            onChange={setStateStaffList}
            onClick={(e: any) => {
              setCurrentStaffNo(e);
              setOpenDialog(true);
            }}
            setDateErrorFlg={setDateErrorFlg}
          />
        </Box>
      )}

      <Box className="btns">
        <TkBackButton />
        {selectFacilityNo && !disabled && (
          <TkButton
            onClick={handleClickSubmit}
            disabled={!res.staffList?.length || dateErrorFlg}
          >
            登録
          </TkButton>
        )}
      </Box>

      <TkMessageDialog
        open={openDialog}
        onCancel={() => {
          setOpenDialog(false);
          setCurrentStaffNo("");
        }}
        onOky={handleSure}
        title="確認（画面遷移します）"
        contextText="　登録せず「育児休業情報登録」画面に遷移した場合は、従業状況更新画面で入力した内容は破棄されます。"
        okText="はい"
        cancelText="いいえ"
      />

      <TkMessageDialog
        open={openDialog2}
        onCancel={() => setOpenDialog2(false)}
        onOky={handleLogin}
        title="確認（情報を登録します）"
        contextText="　入力した内容で登録を行いますが、問題ないでしょうか。"
        okText="はい"
        cancelText="いいえ"
      />
      <TkMessageDialog
        open={openWarning}
        onOky={handleOpenSubmitModal}
        onCancel={() => setOpenWarning(false)}
        onClose={() => setOpenWarning(false)}
        title="警告"
        contextText={TkPropertyMessageGet("TKMSG_SCR0031W")}
        okText="確認"
        cancelText="戻る"
      />
    </Box>
  );
};

export default SCRW060101;
